import React from 'react';
import { Link } from 'react-router-dom';
import { COPYRIGHT_HOLDER } from '../data/legal';
import './Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <h3>Apres AI</h3>
          <p>Rapidly transforming ideas into tangible business solutions through AI-powered web and mobile applications.</p>
        </div>

        <div className="footer-section">
          <h4>Company</h4>
          <ul>
            <li><Link to="/about">About</Link></li>
            <li><Link to="/services">Services</Link></li>
            <li><Link to="/support">Support</Link></li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>Legal</h4>
          <ul>
            <li><Link to="/privacy">Privacy Policy</Link></li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>Contact</h4>
          <ul>
            <li><a href="mailto:support@apresai.dev">support@apresai.dev</a></li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} {COPYRIGHT_HOLDER}. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
